import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { Sparkles, LogOut, ShieldCheck, Truck, FileText } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const navLinkClass = ({ isActive }) =>
  `flex items-center gap-2 px-3 py-2 text-sm font-medium rounded-md transition-colors ${
    isActive
      ? "bg-zinc-900 text-white"
      : "text-zinc-600 hover:text-zinc-900 hover:bg-zinc-100"
  }`;

export default function Layout({ children }) {
  const { user, logout, isAdmin } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-zinc-50">
      <header className="border-b border-zinc-200 bg-white sticky top-0 z-30">
        <div className="max-w-7xl mx-auto px-4 md:px-8 py-3 flex items-center justify-between gap-4">
          <button
            onClick={() => navigate("/")}
            className="flex items-center gap-3 group"
            data-testid="nav-brand"
          >
            <div className="w-9 h-9 rounded-md bg-zinc-900 flex items-center justify-center group-hover:scale-105 transition-transform">
              <Sparkles className="w-5 h-5 text-white" />
            </div>
            <div className="text-left hidden sm:block">
              <div className="text-sm font-semibold tracking-tight text-zinc-900">
                Shipment Code Generator
              </div>
              <div className="text-[10px] uppercase tracking-[0.2em] text-zinc-500">
                Logistics Console
              </div>
            </div>
          </button>

          <nav className="flex items-center gap-1">
            <NavLink to="/" end className={navLinkClass} data-testid="nav-create">
              <FileText className="w-4 h-4" /> <span className="hidden md:inline">Create</span>
            </NavLink>
            <NavLink to="/shipments" className={navLinkClass} data-testid="nav-shipments">
              <Truck className="w-4 h-4" /> <span className="hidden md:inline">Shipments</span>
            </NavLink>
            {isAdmin && (
              <NavLink to="/admin" className={navLinkClass} data-testid="nav-admin">
                <ShieldCheck className="w-4 h-4" /> <span className="hidden md:inline">Admin</span>
              </NavLink>
            )}
          </nav>

          <div className="flex items-center gap-3">
            <div className="text-right hidden sm:block">
              <div className="text-xs font-semibold text-zinc-900" data-testid="nav-user-email">
                {user?.email}
              </div>
              <div className="text-[10px] uppercase tracking-[0.16em] text-zinc-500">
                {user?.role === "admin" ? "Administrator" : "User"}
              </div>
            </div>
            <button
              onClick={logout}
              data-testid="btn-logout"
              className="p-2 rounded-md hover:bg-zinc-100 text-zinc-600 hover:text-zinc-900 transition-colors"
              title="Logout"
            >
              <LogOut className="w-4 h-4" />
            </button>
          </div>
        </div>
      </header>

      <main>{children}</main>
    </div>
  );
}
